const cmsReducer = (data = [], action) => {	
  if (action.type === 'FETCH_ALL_CMS_DATA') {
    return action.payload;
  }
  return data;
};

export default cmsReducer